  $(".popup-button").click(function(){
  $("html").addClass("disable-body");
});
  $('body').on('click', '.mfp-close-btn-in', function() {
    $("html").removeClass('disable-body');
  });
// --------------terms-popup-------------
$(".register-popup--terms").click(function(event){
  event.preventDefault();
  $(".signup-overlay").css({"opacity":"1","visibility":"visible"});
  $("#as-popup--signup").css("z-index","99");
  $(".as-popup--overlay").css("z-index","unset");
  $(".tc-content2").hide();
  $(".tc-content").show();

});

$(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('.fixed-header').addClass('sticky');
    } else {
       $('.fixed-header').removeClass('sticky');
    }
});

$(".register-popup--privacy").click(function(event){
  event.preventDefault();
  $(".signup-overlay").css({"opacity":"1","visibility":"visible"});
  $("#as-popup--signup").css("z-index","99");
  $(".as-popup--overlay").css("z-index","unset");
  $(".tc-content2").show();
  $(".tc-content").hide();
});

$(".tc-close").click(function(event){
  event.preventDefault();
  $(".signup-overlay").css({"opacity":"0","visibility":"hidden"});
  $("#as-popup--signup").css("z-index","99999");
  $(".as-popup--overlay").css("z-index","99999");
});

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
var vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
$( document ).ready(function() {
  $('.no_products_text').hide();
  var ratingslider = $('.all_shipment_details');
  if($(window).width() <=767 ){
    ratingslider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow:"<button type='button' class='rev-prev slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      nextArrow:"<button type='button' class='rev-next slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
    });
  }

var maxwidth = 767;
function createSlick(){
$(".sweets-col-slider").not('.slick-initialized').slick({
  arrow: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='rev-prev slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 64.00 64.00'><path fill='#25030f' d='   M 14.40 34.29   L 26.78 46.65   Q 27.87 47.73 27.30 49.16   Q 27.13 49.59 26.72 49.78   Q 25.06 50.56 23.76 49.26   L 7.88 33.38   A 1.94 1.94 0.0 0 1 7.88 30.63   L 23.90 14.60   Q 25.28 13.22 26.88 14.33   Q 27.11 14.49 27.23 14.74   Q 27.92 16.21 26.77 17.35   L 14.71 29.40   Q 14.11 30.00 14.96 30.00   L 54.63 30.00   Q 56.25 30.00 56.60 31.58   Q 56.65 31.78 56.64 31.99   Q 56.56 34.00 54.55 34.00   L 14.52 34.00   A 0.17 0.17 0.0 0 0 14.40 34.29   Z'/></svg></button>",
  nextArrow:"<button type='button' class='rev-next slick-next pull-right'><svg viewBox='0.00 0.00 64.00 64.00' version='1.1' xmlns='http://www.w3.org/2000/svg'><path fill='#26030f' d='   M 49.60 29.71   L 37.19 17.32   Q 36.09 16.22 36.72 14.79   Q 36.84 14.52 37.06 14.35   Q 38.63 13.13 40.04 14.54   L 56.00 30.50   A 2.12 2.12 0.0 0 1 56.00 33.50   L 40.16 49.33   Q 38.84 50.66 37.21 49.72   Q 36.94 49.57 36.80 49.29   Q 36.04 47.83 37.21 46.66   L 49.38 34.51   Q 49.89 34.00 49.17 34.00   L 9.39 34.00   Q 7.89 34.00 7.44 32.58   Q 7.33 32.23 7.39 31.88   Q 7.66 30.00 9.56 30.00   L 49.48 30.00   A 0.17 0.17 0.0 0 0 49.60 29.71   Z'/></svg></button>",
  responsive: [{
    breakpoint: 1199,
    settings: {
      slidesToShow: 2,
    }
  },
  {
  breakpoint: 767,
  settings: 'unslick'
  }]
});

}
createSlick();
$(window).on( 'resize', createSlick );


var maxwidth = 767;
function createSlick1(){
$(".search-store-slider").not('.slick-initialized').slick({
  arrow: true,
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='rev-prev slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 64.00 64.00'><path fill='#25030f' d='   M 14.40 34.29   L 26.78 46.65   Q 27.87 47.73 27.30 49.16   Q 27.13 49.59 26.72 49.78   Q 25.06 50.56 23.76 49.26   L 7.88 33.38   A 1.94 1.94 0.0 0 1 7.88 30.63   L 23.90 14.60   Q 25.28 13.22 26.88 14.33   Q 27.11 14.49 27.23 14.74   Q 27.92 16.21 26.77 17.35   L 14.71 29.40   Q 14.11 30.00 14.96 30.00   L 54.63 30.00   Q 56.25 30.00 56.60 31.58   Q 56.65 31.78 56.64 31.99   Q 56.56 34.00 54.55 34.00   L 14.52 34.00   A 0.17 0.17 0.0 0 0 14.40 34.29   Z'/></svg></button>",
  nextArrow:"<button type='button' class='rev-next slick-next pull-right'><svg viewBox='0.00 0.00 64.00 64.00' version='1.1' xmlns='http://www.w3.org/2000/svg'><path fill='#26030f' d='   M 49.60 29.71   L 37.19 17.32   Q 36.09 16.22 36.72 14.79   Q 36.84 14.52 37.06 14.35   Q 38.63 13.13 40.04 14.54   L 56.00 30.50   A 2.12 2.12 0.0 0 1 56.00 33.50   L 40.16 49.33   Q 38.84 50.66 37.21 49.72   Q 36.94 49.57 36.80 49.29   Q 36.04 47.83 37.21 46.66   L 49.38 34.51   Q 49.89 34.00 49.17 34.00   L 9.39 34.00   Q 7.89 34.00 7.44 32.58   Q 7.33 32.23 7.39 31.88   Q 7.66 30.00 9.56 30.00   L 49.48 30.00   A 0.17 0.17 0.0 0 0 49.60 29.71   Z'/></svg></button>",
  responsive: [{
    breakpoint: 1199,
    settings: {
      slidesToShow: 5,
    }
  },
  {
  breakpoint: 767,
  settings: 'unslick'
  }]
});

}
createSlick1();
$(window).on( 'resize', createSlick1 );


  $(".trigger_reviews_popup").click(function(e){
    var aa= $(this).attr('data-src');
    $.fancybox.open({
      src: aa, 
      modal: true,
      opts : {
        beforeShow : function( instance, current ) {
          $('body').addClass('review_box_open');
        },
        afterClose: function( instance, current ) {
          $('body').removeClass('review_box_open');
        }
      }
    });
    e.preventDefault();
  });

// Inline popups
$('.site-header').find('#inline-popups').magnificPopup({
delegate: 'a',
mainClass: 'mfp-fade',
removalDelay: 500, //delay removal by X to allow out-animation
callbacks: {
beforeOpen: function() {
   this.st.mainClass = this.st.el.attr('data-effect');
}
},
midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
});

//for mobile
$('.only-mobile').find('#inline-popups').magnificPopup({
delegate: 'a',
mainClass: 'mfp-fade',
removalDelay: 500, //delay removal by X to allow out-animation
callbacks: {
beforeOpen: function() {
   this.st.mainClass = this.st.el.attr('data-effect');
}
},
midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
});

// onload put country
var iso_code = $(document).find('#localization_form select option:selected').attr('value');
if(iso_code == 'GB'){
  $('.popup-button').find('.country span').text('UK');
}else{
  $('.popup-button').find('.country span').text(iso_code);
}

  $(document).on('click','.cheeey-pick-popup .dropdown-button',function(){
console.log('clicked popup');
$(this).addClass('scbtn');
var docClick = function(ev){
  if(!$(ev.target).hasClass('dropdown-button')) {
    closeDropdown();
  }
}

var closeDropdown = function() {
  $(".dropdown-menu").removeClass("show-menu");
  $('.dropdown-button').removeClass('scbtn');
  $(document).unbind('click', docClick);
}

if($(".dropdown-menu").hasClass("show-menu")) {
  closeDropdown();
}else{
  $(document).bind('click', docClick )
  $(".dropdown-menu").addClass("show-menu");
}

$(".dropdown-menu > li").click(function(){
  closeDropdown();
});
$(".dropdown-menu.dropdown-select > li").click(function() {
  $(".dropdown-button").html($(this).html());
});
});

//   2nd dropdown
$(document).on('click','.cheeey-pick-popup .top-banner--input',function(){
  console.log('ghhhhhjjjjjj')
$(this).addClass('scbtn1');
var docClick1 = function(ev){
  if(!$(ev.target).hasClass('top-banner--input')) {
    closeDropdown1();
  }
}

var closeDropdown1 = function() {
  $(".dropdown-menu1").removeClass("show-menu1");
  $('.top-banner--input').removeClass('scbtn1');
  $(document).unbind('click', docClick1);
}

if($(".dropdown-menu1").hasClass("show-menu1")) {
  closeDropdown1();
}else{
  $(document).bind('click', docClick1 )
  $(".dropdown-menu1").addClass("show-menu1");
}

$(".dropdown-menu1 > li").click(function(){
  closeDropdown1();
});
$(".dropdown-menu1.dropdown-select1 > li").click(function() {
  $(".top-banner--input").html($(this).html());
});
});
$('.dropdown-select1 li').click(function(){
var country = $(this).text();
var iso_code =  $('#localization_form select option[data-country="'+country+'"]').attr('value');
if(iso_code == 'GB'){
  $('.popup-button').find('.country span').text('UK');
}else{
  $('.popup-button').find('.country span').text(iso_code);
}
$('#localization_form select').val(iso_code).change();
});

$(".check_city_btn").click(function(){  
var country =  $(".dropdown-button").text();
var country2 =  $(".top-banner--input").text();

var country_placeholder =  $(".dropdown-button").attr('data-label');
var country2_placeholder =  $(".top-banner--input").attr('data-label');


var parent = $('.ttop-input-wrapper');
parent.next().text('');
var err = "";

if(country.indexOf(country_placeholder) < 0 && country2.indexOf(country2_placeholder) < 0)
{
// if(country2 == 'Canada'){
//         window.location.href = "https://ca.cherrypick.city/collections";
// }else if(country2 == 'Netherlands'){
//         window.location.href = "https://nl.cherrypick.city/collections";
// }else{
//   window.location.href = "https://cherrypick.city/collections";     
// }
  $('#localization_form input[type="submit"]').click();
  parent.next().text('');
} else {
  if(country.indexOf(country_placeholder) > -1){
    err = $(".dropdown-button").attr('data-error');
  } else {
    err = $(".top-banner--input").attr('data-error');
  }
  $(".banner-left--inner .form-error").text(err).show();
}
});


//extended cate page
$('.sweets-col a.block_cate').each(function(){
$(this).on('click', function(){
  // $('.loading_collection_products').css('display','flex');
  $('.collection-product-block').css('display','none');
  $('.sweets-col a.block_cate').removeClass('active');
  $(this).addClass('active');
  var category = $(this).attr('data-category').toLowerCase();;
  $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').addClass('load');


  
  if($('body').hasClass('collections-category-extended')){
  var url = window.location.href;
    if(url.includes('?view_cat')){
      var new_url = url.split('?')[0];
      window.history.pushState({}, null, new_url+ '?view_cat='+category);
      // window.location.href = new_url + '?view_cat='+category;
    }else if(url.includes('collections#')){
      var new_url = url.split('#')[0];
      window.history.pushState({}, null, new_url+ '?view_cat='+category);
      // window.location.href = new_url + '?view_cat='+category;
    }else{
      window.history.pushState({}, null, url+ '?view_cat='+category);
      // window.location.href = url + '?view_cat='+category;
    }
  }


  $('.collection-product .collection-product-block').each(function(){
    if($(this).hasClass(category)){
      $(this).css('display','flex');
        $(this).find('.collection-product-right .product-right-content').each(function(){
          var tags = $(this).attr('data-tags');
           if(tags.includes(category)){
             $(this).css('display','block');
           }else{
             $(this).css('display','none');
           }
        });
      $(this).find('.collection-product-right .product-right-content:visible:gt(4)').css('display','none');
      var url = $(this).find('.product-left-btn a').attr('data-tag-url');
      $(this).find('.product-left-btn a').attr('href',url+'/'+category);
       setTimeout(function() {
          $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').removeClass('load');
         }, 2000);
    }else{
      $(this).css('display','none');
    }
  });

    setTimeout(function() {
      var length = $('.collection-product .collection-product-block:visible').length;
      if(length > 0){
        // $('.no_products_text').hide();
      }else{
        // $('.no_products_text').show();
      }
      
      
    }, 2000);
  
});
});
  
//collections list page

$(document).on('change','.collection-product-block .collection-product-right .product-variant select', function(){
  var variant_id = $(this).find('option:selected').attr('data-id');
  var variant_price = $(this).find('option:selected').attr('data-price');
  $(this).parents('.pr-content').siblings('.pr-image-weapper').find('p.grid-link__title').attr('data-variant-id',variant_id);
  $(this).parents('.pr-content').find('p.price').html(variant_price);
});

$(document).on('change','.product-recommendations .product-variant select', function(){
  var variant_id = $(this).find('option:selected').attr('data-id');
  var variant_price = $(this).find('option:selected').attr('data-price');
  $(this).parents('.pr-content').siblings('a.grid-link').find('p.grid-link__title').attr('data-variant-id',variant_id);
  $(this).parents('.pr-content').find('p.price').html(variant_price);
});

 

$('.collection-category ul li').each(function(){
$(this).find('a').on('click', function(){
  // $('.loading_collection_products').css('display','flex');
  $('.collection-product-block').css('display','none');
  $('.collection-category ul li').removeClass('active');
  $(this).parent('li').addClass('active');
  var category = $(this).attr('data-category').toLowerCase();
  $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').addClass('load');

  // setTimeout(function(){
  //   $('.collection-product .wrapper').find('.collection-product-block').each(function(){
  //     $(this).find('.product-right-content').each(function(){
  //       $('.product-right-content').removeClass('load');
  //     })
  //     $(this).find('.product-left-content').each(function(){
  //       $('.product-left-content').removeClass('load');
  //     })
    
  //   })
  // },4000);
  
  if($('body').hasClass('template-list-collections')){
  var url = window.location.href;
    if(url.includes('?view_cat')){
      var new_url = url.split('?')[0];
      window.history.pushState({}, null, new_url+ '?view_cat='+category);
      // window.location.href = new_url + '?view_cat='+category;
    }else if(url.includes('collections#')){
      var new_url = url.split('#')[0];
      window.history.pushState({}, null, new_url+ '?view_cat='+category);
      // window.location.href = new_url + '?view_cat='+category;
    }else{
      window.history.pushState({}, null, url+ '?view_cat='+category);
      // window.location.href = url + '?view_cat='+category;
    }
  }

  
    $('.loading_collection_products').css('display','none');
  
  $('.collection-product .collection-product-block').each(function(){
    if($(this).hasClass(category)){
      $(this).css('display','flex');
        $(this).find('.collection-product-right .product-right-content').each(function(){
          var tags = $(this).attr('data-tags');
           if(tags.includes(category)){
             $(this).css('display','block');
           }else{
             $(this).css('display','none');
           }
        });
      $(this).find('.collection-product-right .product-right-content:visible:gt(4)').css('display','none');
      var url = $(this).find('.product-left-btn a').attr('data-tag-url');
      $(this).find('.product-left-btn a').attr('href',url+'/'+category);
      $(this).find('.collection-product-right .view_all_link a').attr('href',url+'/'+category);
       setTimeout(function() {
          $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').removeClass('load');
         }, 2000); 
        var visible_length = $(this).find('.collection-product-right .product-right-content:visible').length;
         if(visible_length < 1){
            var ori_url =  $(this).find('.collection-product-right .view_all_link a').attr('data-ori-url');
            $(this).find('.collection-product-right .view_all_link a').attr('href',ori_url);
            $(this).find('.product-left-btn a').attr('href',ori_url);
           $(this).find('.collection-product-right .product-right-content:lt(5)').show();
          // $(this).css('display','none');
          }
      // setTimeout(function(){
      //   $('.collection-product .collection-product-block').each(function(){
      //           var visible_length = $(this).find('.collection-product-righ .product-right-content:visible').length;
      //           console.log(visible_length);
                
      //           if(visible_length < 1){
      //           $(this).css('display','none');
      //           }
      //       });
      // },2200)
    }else{
      $(this).css('display','none');
    }
  });
    
        // setTimeout(function() {
        //   var length = $('.collection-product .collection-product-block:visible').length;
        //   if(length > 0){
        //     $('.no_products_text').hide();
        //   }else{
        //     $('.no_products_text').show();
        //   }
        // }, 2000);
  
  // setTimeout(function() {
  //   $('.collection-product .wrapper').removeClass('loading');
  // },1500);
});
});

  //collection list extended
$('.collection-category .collection-extended-category ul li').each(function(){
$(this).find('a').on('click', function(){
  // $('.loading_collection_products').css('display','flex');
  $('.collection-product-block').css('display','none');
  $('.collection-category .collection-extended-category ul li').removeClass('active');
  $(this).parent('li').addClass('active');
  var category = $(this).attr('data-category').toLowerCase();
  $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').addClass('load');
  
  if($('body').hasClass('template-list-collections')){
  var url = window.location.href;
    if(url.includes('?view_cat')){
      var new_url = url.split('?')[0];
      window.history.pushState({}, null, new_url+ '?view_cat='+category+'&cate=extended');
      // window.location.href = new_url + '?view_cat='+category;
    }else if(url.includes('collections#')){
      var new_url = url.split('#')[0];
      window.history.pushState({}, null, new_url+ '?view_cat='+category);
      // window.location.href = new_url + '?view_cat='+category;
    }else{
      window.history.pushState({}, null, url+ '?view_cat='+category);
      // window.location.href = url + '?view_cat='+category;
    }
  }

  
    $('.loading_collection_products').css('display','none');
  
  $('.collection-product .collection-product-block').each(function(){
    if($(this).hasClass(category)){
      $(this).css('display','flex');
        $(this).find('.collection-product-right .product-right-content').each(function(){
          var tags = $(this).attr('data-tags');
           if(tags.includes(category)){
             $(this).css('display','block');
           }else{
             $(this).css('display','none');
           }
        });
      $(this).find('.collection-product-right .product-right-content:visible:gt(4)').css('display','none');
      var url = $(this).find('.product-left-btn a').attr('data-tag-url');
      $(this).find('.product-left-btn a').attr('href',url+'/'+category);
      $(this).find('.collection-product-right .view_all_link a').attr('href',url+'/'+category);
       setTimeout(function() {
          $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').removeClass('load');
         }, 2000);

        var visible_length = $(this).find('.collection-product-right .product-right-content:visible').length;
         if(visible_length < 1){
            var ori_url =  $(this).find('.collection-product-right .view_all_link a').attr('data-ori-url');
            $(this).find('.collection-product-right .view_all_link a').attr('href',ori_url);
            $(this).find('.product-left-btn a').attr('href',ori_url);
           $(this).find('.collection-product-right .product-right-content:lt(5)').show();
          // $(this).css('display','none');
          }
    }else{
      $(this).css('display','none');
    }
  });
    

  // setTimeout(function() {
  //   $('.collection-product .wrapper').removeClass('loading');
  // },1500);
});
});
  
if(!$('body').hasClass('template-index')){

if($('body').hasClass('template-list-collections')){
var get_url = window.location.href;
console.log(get_url);
if(get_url.includes('?view_cat')){
      if(get_url.includes('&cate=extended')){
        $('.collection-extended-category').css('display','block');
        // $('.loading_collection_products').css('display','flex');
        $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').addClass('load');
        console.log('yes get');
        var url_category = get_url.split('?view_cat=')[1];
        var url_category = url_category.split('&cate')[0].trim();
        if(url_category.includes('#')){
          var url_category = url_category.split('#')[0].trim();
        }
        $('.collection-category .collection-extended-category ul li').removeClass('active');
        $('.collection-category .collection-extended-category ul li a[data-category='+url_category+']').parent('li').addClass('active');
        
        
        // $('.loading_collection_products').css('display','none');
         $('.collection-product .collection-product-block').each(function(){
          if($(this).hasClass(url_category)){
            $(this).css('display','flex');
              $(this).find('.collection-product-right .product-right-content').each(function(){
                var tags = $(this).attr('data-tags');
                 if(tags.includes(url_category)){
                   $(this).css('display','block');
                 }else{
                   $(this).css('display','none');
                 }
              });
            $(this).find('.collection-product-right .product-right-content:visible:gt(4)').css('display','none');
            var url = $(this).find('.product-left-btn a').attr('data-tag-url');
            $(this).find('.product-left-btn a').attr('href',url+'/'+url_category);
            $(this).find('.collection-product-right .view_all_link a').attr('href',url+'/'+url_category);
             setTimeout(function() {
            $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').removeClass('load');
               }, 2000);
              var visible_length = $(this).find('.collection-product-right .product-right-content:visible').length;
              if(visible_length < 1){
                var ori_url =  $(this).find('.collection-product-right .view_all_link a').attr('data-ori-url');
                $(this).find('.collection-product-right .view_all_link a').attr('href',ori_url);
                $(this).find('.product-left-btn a').attr('href',ori_url);
                $(this).find('.collection-product-right .product-right-content:lt(5)').show();
              // $(this).css('display','none');
              }
          }else{
            $(this).css('display','none');
          }
        });
         // setTimeout(function() {
         //  var length = $('.collection-product .collection-product-block:visible').length;
         //  if(length > 0){
         //    $('.no_products_text').hide();
         //  }else{
         //    $('.no_products_text').show();
         //  }
         //  }, 2000);
      }else{
        // $('.loading_collection_products').css('display','flex');
        $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').addClass('load');
        console.log('yes get');
        var url_category = get_url.split('?view_cat=')[1].trim();
        if(url_category.includes('#')){
          var url_category = url_category.split('#')[0].trim();
        }
        $('.collection-category ul li').removeClass('active');
        $('.collection-category ul li a[data-category='+url_category+']').parent('li').addClass('active');
        
          $('.loading_collection_products').css('display','none');
         $('.collection-product .collection-product-block').each(function(){
          if($(this).hasClass(url_category)){
            $(this).css('display','flex');
              $(this).find('.collection-product-right .product-right-content').each(function(){
                var tags = $(this).attr('data-tags');
                 if(tags.includes(url_category)){
                   $(this).css('display','block');
                 }else{
                   $(this).css('display','none');
                 }
              });
            $(this).find('.collection-product-right .product-right-content:visible:gt(4)').css('display','none');
            var url = $(this).find('.product-left-btn a').attr('data-tag-url');
            $(this).find('.product-left-btn a').attr('href',url+'/'+url_category);
            $(this).find('.collection-product-right .view_all_link a').attr('href',url+'/'+url_category);
             setTimeout(function() {
            $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').removeClass('load');
               }, 2000);
              var visible_length = $(this).find('.collection-product-right .product-right-content:visible').length;
              if(visible_length < 1){
               var ori_url =  $(this).find('.collection-product-right .view_all_link a').attr('data-ori-url');
                $(this).find('.collection-product-right .view_all_link a').attr('href',ori_url);
                $(this).find('.product-left-btn a').attr('href',ori_url);
                $(this).find('.collection-product-right .product-right-content:lt(5)').show();
                // $(this).css('display','none');
              }
          }else{
            $(this).css('display','none');
          }
        });

        // setTimeout(function() {
        //   var length = $('.collection-product .collection-product-block:visible').length;
        //   if(length > 0){
        //     $('.no_products_text').hide();
        //   }else{
        //     $('.no_products_text').show();
        //   }
        //   }, 2000);
        
      }
}else{
  $('.collection-category ul li:first a').trigger('click');
  
    // var category = $('.collection-category ul li.active a').attr('data-category');
    // $('.collection-product .collection-product-block').each(function(){
    //       if($(this).hasClass(category)){
    //         $(this).css('display','flex');
    //           $(this).find('.collection-product-right .product-right-content').each(function(){
    //               var tags = $(this).attr('data-tags');
    //                if(tags.includes(category)){
    //                  $(this).css('display','block');
    //                }else{
    //                  $(this).css('display','none');
    //                }
    //             });
    //           $(this).find('.collection-product-right .product-right-content:visible:gt(3)').css('display','none');
    //           var url = $(this).find('.collection-product-left .product-left-btn a').attr('data-tag-url');
    //           $(this).find('.collection-product-left .product-left-btn a').attr('href',url+'/'+category);
    //       }else{
    //         $(this).css('display','none');
    //       }
    // });
}
}

//square categories
  if($('body').hasClass('collections-category-extended')){
      var get_url = window.location.href;
      console.log(get_url);
      if(get_url.includes('?view_cat')){
        // $('.loading_collection_products').css('display','flex');
        $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').addClass('load');
        console.log('yes get');
        var url_category = get_url.split('?view_cat=')[1].trim();
        if(url_category.includes('#')){
          var url_category = url_category.split('#')[0].trim();
        }
        $('.sweets-col a.block_cate').removeClass('active');
        $('.sweets-col a.block_cate[data-category='+url_category+']').addClass('active');
        
         $('.collection-product .collection-product-block').each(function(){
          if($(this).hasClass(url_category)){
            $(this).css('display','flex');
              $(this).find('.collection-product-right .product-right-content').each(function(){
                var tags = $(this).attr('data-tags');
                 if(tags.includes(url_category)){
                   $(this).css('display','block');
                 }else{
                   $(this).css('display','none');
                 }
              });
            $(this).find('.collection-product-right .product-right-content:visible:gt(3)').css('display','none');
            var url = $(this).find('.product-left-btn a').attr('data-tag-url');
            $(this).find('.product-left-btn a').attr('href',url+'/'+url_category);
            // $(this).find('.collection-product-right .product-right-content-default.view_all_link a').attr('href',url+'/'+category);
             setTimeout(function() {
            $('.collection-product-block .product-left-content,.collection-product-block .product-left-btn,.collection-product-block .product-right-content').removeClass('load');
               }, 2000);
          }else{
            $(this).css('display','none');
          }
        });
          
       }else{
          $('.sweets-col a.block_cate:first').trigger('click');
      }
  }
}
});


// pdp tabs
$('.product-detail-tab .tabs-stage .tab-content').hide();
$('.product-detail-tab .tabs-stage .tab-content:first-child').show();
$('.product-detail-tab .tabs-nav li:first-child').addClass('tab-active');

// Change tab class and display content
$('.product-detail-tab .tabs-nav a').on('click', function(event){
  event.preventDefault();
  if(!$(this).hasClass('disabled')){
    $('.product-detail-tab .tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.product-detail-tab .tabs-stage .tab-content').hide();
    if($('body').hasClass('template-collection')){
      $(this).parents('.tabs-nav').siblings('.tabs-stage').find($(this).attr('href')).show();
    }else{
      $($(this).attr('href')).show();
    }
  }
});

// social sharing icon
$(document).on('click','.social-sharing-icon',function(){
  $(".social-sharing, .social-sharing-icon").toggleClass("active");
});


// quantity box
$(function() {
  // $(".quantity-arrow-minus").click(function() {
    $(document).on('click','.quantity-arrow-minus', function(){
    var $quantityNum = $(this).siblings(".quantity-num");
    if ($quantityNum.val() > 1) {
      $quantityNum.val(+$quantityNum.val() - 1);
    }
  });

  $(document).on('click','.quantity-arrow-plus', function(){
  // $(".quantity-arrow-plus").click(function() {
    var $quantityNum = $(this).siblings(".quantity-num");
    $quantityNum.val(+$quantityNum.val() + 1);
  });
});





//google map api
$(document).ready(function() {

  // const autocomplete = new google.maps.places.Autocomplete("Dynamic Dreamz, Vijay Cross Road, above Brand Factory Outlet, Naranpura, Ahmedabad, Gujarat, India", {
  //   fields: ["place_id", "geometry", "formatted_address", "name", "rating", "user_ratings_total"],
  // });
  //  console.log('auto',autocomplete)
    
  // const map_id = "map-coll";
  // const map = new google.maps.Map(document.getElementById(map_id), {
  //   center: { lat: -33.8688, lng: 151.2195 },
  //   zoom: 13,
  // });
 
  //   autocomplete.bindTo("bounds", map);
  //   map.controls[google.maps.ControlPosition.TOP_LEFT].push("Almond House");
  //   const infowindow = new google.maps.InfoWindow();
  //   const infowindowContent = document.getElementById("infowindow-content");

  // var service = new google.maps.places.PlacesService(document.getElementById(map_id));

  // console.log(service);
  // service.getDetails({
  //     placeId: "ChIJ2fNZsMQ0GkcRCt39huGpijo"
  //   },
  //   function(place, status) {
  //     if (status === google.maps.places.PlacesServiceStatus.OK) {
  //       var rating = place.rating;
  //       console.log('rating',rating)
  //       // $('.google_rating').html(rating);
  //     }
  //   });
    
  //   infowindow.setContent(infowindowContent);
  //     const marker = new google.maps.Marker({ map: map });
      
  //     marker.addListener("click", () => {
  //     infowindow.open(map, marker);
  //     });
  //     // marker.click();
  // // marker.setPlace({
  // //     placeId: place.place_id,
  // //     location: place.geometry.location,
  // //   });
  // // console.log(infowindow)
  // //   const place = autocomplete.getPlace();
  // //   console.log('place',place)
  // autocomplete.addListener("place_changed", () => {
  //   infowindow.close();

  //   const place = autocomplete.getPlace();

  //   if (!place.geometry || !place.geometry.location) {
  //     return;
  //   }

  //   if (place.geometry.viewport) {
  //     map.fitBounds(place.geometry.viewport);
  //   } else {
  //     map.setCenter(place.geometry.location);
  //     map.setZoom(17);
  //   }

  //   // Set the position of the marker using the place ID and location.
  //   // @ts-ignore This should be in @typings/googlemaps.
  //   marker.setPlace({
  //     placeId: place.place_id,
  //     location: place.geometry.location,
  //   });
  //   marker.setVisible(true);
  //   infowindowContent.children.namedItem("place-name").textContent = place.name;
  //   infowindowContent.children.namedItem("place-id").textContent =
  //     place.place_id;
  //   infowindowContent.children.namedItem("place-address").textContent =
  //     place.formatted_address;
  //   infowindowContent.children.namedItem("place-ratings").textContent =
  //     place.rating;
  //     infowindowContent.children.namedItem("rating-totals").textContent =
  //     place.user_ratings_total;
  //   infowindow.open(map, marker);
  // });
  //  $('#infowindow-content').hide();
  
  // const map = new google.maps.Map(document.getElementById("map"), {
  //   center: central_park,
  //   zoom: 15
  // });
  // var request = {
  //   placeId: 'ChIJc4S6pLCTyzsR6kLBIA5o9XM' // example: ChIJN1t_tDeuEmsRUsoyG83frY4
  // };

  // var service = new google.maps.places.PlacesService(map); // map is your map object

  // service.getDetails(request, function(place, status) {
  //   if (status == google.maps.places.PlacesServiceStatus.OK) {
  //     console.log(place.reviews);
  //   }
  // });
  // if($('body').hasClass('template-list-collections')){
  //     $('.collection-product-block').each(function(){
  //       const input = $(this).find('.collection-product-left .product-left-content .collection-content .collection-title h2').text();
  //       console.log(input);
  //         // Specify just the place data fields that you need.
  //       const autocomplete = new google.maps.places.Autocomplete(input, {
  //         fields: ["place_id", "geometry", "formatted_address", "name", "rating", "user_ratings_total"],
  //       });
  //       console.log('auto',autocomplete)
  //       const map_id = "map-" + input;
  //       const map = new google.maps.Map(document.getElementById(map_id), {
  //         center: { lat: -33.8688, lng: 151.2195 },
  //         zoom: 13,
  //       });
  //        autocomplete.bindTo("bounds", map);
  //        const place = autocomplete.getPlace();
  //       console.log('place',place)
  //     });
  // } 


    //with name find 
  // var sydney = new google.maps.LatLng(-33.8688, 151.2195);

  // infowindow = new google.maps.InfoWindow();

  // map = new google.maps.Map(
  //     document.getElementById('map-coll'), {center: sydney, zoom: 15});

  // var request = {
  //   query: 'Dynamic Dreamz, Vijay Cross Road, above Brand Factory Outlet, Naranpura, Ahmedabad, Gujarat, India',
  //   // fields: ['name', 'geometry'],
  //   fields: ["place_id", "geometry", "formatted_address", "name", "rating", "user_ratings_total"],
  // };

  // var service = new google.maps.places.PlacesService(map);

  // service.findPlaceFromQuery(request, function(results, status) {
  //   if (status === google.maps.places.PlacesServiceStatus.OK) {
  //     for (var i = 0; i < results.length; i++) {
  //       // createMarker(results[i]);
  //     }
  //     console.log('rating',results.rating);
  //     console.log('user_ratings_total',results.user_ratings_total);
  //     console.log('place_id',results.place_id);
  //     // map.setCenter(results[0].geometry.location);
  //   }
  // });
});
jQuery(document).ready(function($) {
  const map_id = "map-coll";
  // var service = new google.maps.places.PlacesService(document.getElementById(map_id));

  // console.log(service);
  // service.getDetails({
  //     placeId: "ChIJ5WL5H2pO4DsRwxmxxX5iMxw"
  //   },
  //   function(place, status) {
  //     if (status === google.maps.places.PlacesServiceStatus.OK) {
  //       var rating = place.rating;
  //       var user_total_rating = place.user_ratings_total;
  //       console.log('ratings to',rating)
  //       console.log('user_total_rating to',user_total_rating)
  //       // $('.google_rating').html(rating);
  //     }
  //   });

     if($('body').hasClass('template-list-collections') || $('body').hasClass('template-search')){
        $('.collection-product-block').each(function(){
          var $this = $(this);
          var store_place_id = $(this).attr('data-place-id');
          var google_rating = $this.data('google-rating');
          var review_count = $this.data('review-count');

          // Debugging: Print values to the console
          // console.log('Google Rating:', store_place_id);
          // console.log('Review Count:', review_count);
          if(google_rating && review_count){
            $($this).find('.product-right-review .gallery-review-right p').html(google_rating+'<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.54894 1.42705C4.8483 0.505741 6.1517 0.50574 6.45106 1.42705L6.95934 2.99139C7.09321 3.40341 7.47717 3.68237 7.9104 3.68237H9.55524C10.524 3.68237 10.9267 4.92199 10.143 5.49139L8.81232 6.4582C8.46183 6.71285 8.31518 7.16422 8.44905 7.57624L8.95733 9.14058C9.25669 10.0619 8.20221 10.828 7.41849 10.2586L6.08779 9.2918C5.7373 9.03715 5.2627 9.03715 4.91221 9.2918L3.58151 10.2586C2.7978 10.828 1.74331 10.0619 2.04267 9.14058L2.55095 7.57624C2.68483 7.16422 2.53817 6.71285 2.18768 6.4582L0.856976 5.49139C0.0732617 4.92199 0.476037 3.68237 1.44476 3.68237H3.0896C3.52283 3.68237 3.90678 3.40341 4.04066 2.99139L4.54894 1.42705Z" fill="#FFB800"/></svg>');
            $($this).find('.product-right-review .gallery-review-right span').html('('+review_count+')');
            $($this).find('.product-right-review').show();
            // console.log(store_place_id)
            // var service = new google.maps.places.PlacesService(document.getElementById(map_id));
            // service.getDetails({
            //   placeId: store_place_id
            // },
            // function(place, status) {
            //   if (status === google.maps.places.PlacesServiceStatus.OK) {
            //     var rating = place.rating;
            //     var user_total_rating = place.user_ratings_total;
            //     $($this).find('.product-right-review .gallery-review-right p').html(rating+'<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.54894 1.42705C4.8483 0.505741 6.1517 0.50574 6.45106 1.42705L6.95934 2.99139C7.09321 3.40341 7.47717 3.68237 7.9104 3.68237H9.55524C10.524 3.68237 10.9267 4.92199 10.143 5.49139L8.81232 6.4582C8.46183 6.71285 8.31518 7.16422 8.44905 7.57624L8.95733 9.14058C9.25669 10.0619 8.20221 10.828 7.41849 10.2586L6.08779 9.2918C5.7373 9.03715 5.2627 9.03715 4.91221 9.2918L3.58151 10.2586C2.7978 10.828 1.74331 10.0619 2.04267 9.14058L2.55095 7.57624C2.68483 7.16422 2.53817 6.71285 2.18768 6.4582L0.856976 5.49139C0.0732617 4.92199 0.476037 3.68237 1.44476 3.68237H3.0896C3.52283 3.68237 3.90678 3.40341 4.04066 2.99139L4.54894 1.42705Z" fill="#FFB800"/></svg>');
            //     if(user_total_rating > 999){
            //       var originalNumber = user_total_rating;
            //       var convertedNumber = originalNumber / 1000;
            //       var convertedNumber_new = convertedNumber;
            //       var roundedNumber = convertedNumber_new.toFixed(1);
                  
            //       console.log(parseFloat(roundedNumber)); // Output: 12.8
            //       $($this).find('.product-right-review .gallery-review-right span').html('('+parseFloat(roundedNumber)+'k)');
            //     }else{
            //       $($this).find('.product-right-review .gallery-review-right span').html('('+user_total_rating+')');
            //     }
            //     // $($this).find('.product-right-review .gallery-review-right span').html('('+user_total_rating+')');
            //     $($this).find('.product-right-review').show();
            //     // console.log('ratings to',rating)
            //     // console.log('user_total_rating to',user_total_rating)
            //   }
            // });
          }
        });
     }
    if($('body').hasClass('template-page')){
      $('.stores-section .grid__item').each(function(){
         var $this = $(this);
         var store_place_id = $(this).attr('data-place-id');
         var google_rating = $this.attr('data-google-rating');
         var review_count = $this.attr('data-review-count');
         console.log(google_rating,review_count);
         if(google_rating && review_count){
           $($this).find('.gallery-review .gallery-review-right p').html(google_rating+'<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.54894 1.42705C4.8483 0.505741 6.1517 0.50574 6.45106 1.42705L6.95934 2.99139C7.09321 3.40341 7.47717 3.68237 7.9104 3.68237H9.55524C10.524 3.68237 10.9267 4.92199 10.143 5.49139L8.81232 6.4582C8.46183 6.71285 8.31518 7.16422 8.44905 7.57624L8.95733 9.14058C9.25669 10.0619 8.20221 10.828 7.41849 10.2586L6.08779 9.2918C5.7373 9.03715 5.2627 9.03715 4.91221 9.2918L3.58151 10.2586C2.7978 10.828 1.74331 10.0619 2.04267 9.14058L2.55095 7.57624C2.68483 7.16422 2.53817 6.71285 2.18768 6.4582L0.856976 5.49139C0.0732617 4.92199 0.476037 3.68237 1.44476 3.68237H3.0896C3.52283 3.68237 3.90678 3.40341 4.04066 2.99139L4.54894 1.42705Z" fill="#FFB800"/></svg>');
           $($this).find('.gallery-review .gallery-review-right span').html('('+review_count+')');
           $($this).find('.gallery-review').show();
           //  var service = new google.maps.places.PlacesService(document.getElementById(map_id));
           //  service.getDetails({
           //    placeId: store_place_id
           //  },
           //  function(place, status) {
           //    console.log("status:",status); 
           //    if (status === google.maps.places.PlacesServiceStatus.OK) {
           //      var rating = place.rating;
           //      var user_total_rating = place.user_ratings_total;
           //      $($this).find('.gallery-review .gallery-review-right p').html(rating+'<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.54894 1.42705C4.8483 0.505741 6.1517 0.50574 6.45106 1.42705L6.95934 2.99139C7.09321 3.40341 7.47717 3.68237 7.9104 3.68237H9.55524C10.524 3.68237 10.9267 4.92199 10.143 5.49139L8.81232 6.4582C8.46183 6.71285 8.31518 7.16422 8.44905 7.57624L8.95733 9.14058C9.25669 10.0619 8.20221 10.828 7.41849 10.2586L6.08779 9.2918C5.7373 9.03715 5.2627 9.03715 4.91221 9.2918L3.58151 10.2586C2.7978 10.828 1.74331 10.0619 2.04267 9.14058L2.55095 7.57624C2.68483 7.16422 2.53817 6.71285 2.18768 6.4582L0.856976 5.49139C0.0732617 4.92199 0.476037 3.68237 1.44476 3.68237H3.0896C3.52283 3.68237 3.90678 3.40341 4.04066 2.99139L4.54894 1.42705Z" fill="#FFB800"/></svg>');
           //      if(user_total_rating > 999){
           //        var originalNumber = user_total_rating;
           //        var convertedNumber = originalNumber / 1000;
           //        var convertedNumber_new = convertedNumber;
           //        var roundedNumber = convertedNumber_new.toFixed(1);
                  
           //        console.log(parseFloat(roundedNumber)); // Output: 12.8
           //        $($this).find('.gallery-review .gallery-review-right span').html('('+parseFloat(roundedNumber)+'k)');
           //      }else{
           //        $($this).find('.gallery-review .gallery-review-right span').html('('+user_total_rating+')');
           //      }
           //      $($this).find('.gallery-review').show();
           //      console.log('ratings to',rating)
           //      // console.log('user_total_rating to',user_total_rating)
           //    }
           //  });
           // console.log("im hereeeeeeeeeeee:",status); 
        }
      });
    }
    if($('body').hasClass('template-index')){
      $('.stores-section .grid__item').each(function(){
         var $this = $(this);
         var store_place_id = $(this).attr('data-place-id');
         var google_rating = $(this).attr('data-google-rating');
         var review_count = $(this).attr('data-review-count');
         // console.log('Google Rating:', store_place_id);
         // console.log('Review Count:', review_count);
         if(google_rating && review_count){
            $($this).find('.gallery-review .gallery-review-right p').html(google_rating+'<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.54894 1.42705C4.8483 0.505741 6.1517 0.50574 6.45106 1.42705L6.95934 2.99139C7.09321 3.40341 7.47717 3.68237 7.9104 3.68237H9.55524C10.524 3.68237 10.9267 4.92199 10.143 5.49139L8.81232 6.4582C8.46183 6.71285 8.31518 7.16422 8.44905 7.57624L8.95733 9.14058C9.25669 10.0619 8.20221 10.828 7.41849 10.2586L6.08779 9.2918C5.7373 9.03715 5.2627 9.03715 4.91221 9.2918L3.58151 10.2586C2.7978 10.828 1.74331 10.0619 2.04267 9.14058L2.55095 7.57624C2.68483 7.16422 2.53817 6.71285 2.18768 6.4582L0.856976 5.49139C0.0732617 4.92199 0.476037 3.68237 1.44476 3.68237H3.0896C3.52283 3.68237 3.90678 3.40341 4.04066 2.99139L4.54894 1.42705Z" fill="#FFB800"/></svg>');
            $($this).find('.gallery-review .gallery-review-right span').html('('+review_count+')');
            $($this).find('.gallery-review').show();
            // var service = new google.maps.places.PlacesService(document.getElementById(map_id));
            // service.getDetails({
            //   placeId: store_place_id
            // },
            // function(place, status) {
            //   if (status === google.maps.places.PlacesServiceStatus.OK) {
            //     var rating = place.rating;
            //     var user_total_rating = place.user_ratings_total;
            //     $($this).find('.gallery-review .gallery-review-right p').html(rating+'<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.54894 1.42705C4.8483 0.505741 6.1517 0.50574 6.45106 1.42705L6.95934 2.99139C7.09321 3.40341 7.47717 3.68237 7.9104 3.68237H9.55524C10.524 3.68237 10.9267 4.92199 10.143 5.49139L8.81232 6.4582C8.46183 6.71285 8.31518 7.16422 8.44905 7.57624L8.95733 9.14058C9.25669 10.0619 8.20221 10.828 7.41849 10.2586L6.08779 9.2918C5.7373 9.03715 5.2627 9.03715 4.91221 9.2918L3.58151 10.2586C2.7978 10.828 1.74331 10.0619 2.04267 9.14058L2.55095 7.57624C2.68483 7.16422 2.53817 6.71285 2.18768 6.4582L0.856976 5.49139C0.0732617 4.92199 0.476037 3.68237 1.44476 3.68237H3.0896C3.52283 3.68237 3.90678 3.40341 4.04066 2.99139L4.54894 1.42705Z" fill="#FFB800"/></svg>');
            //     if(user_total_rating > 999){
            //       var originalNumber = user_total_rating;
            //       var convertedNumber = originalNumber / 1000;
            //       var convertedNumber_new = convertedNumber;
            //       var roundedNumber = convertedNumber_new.toFixed(1);
                  
            //       console.log(parseFloat(roundedNumber)); // Output: 12.8
            //       $($this).find('.gallery-review .gallery-review-right span').html('('+parseFloat(roundedNumber)+'k)');
            //     }else{
            //       $($this).find('.gallery-review .gallery-review-right span').html('('+user_total_rating+')');
            //     }
            //     // $($this).find('.gallery-review .gallery-review-right span').html('('+user_total_rating+')');
            //     $($this).find('.gallery-review').show();
            //     // console.log('ratings to',rating)
            //     // console.log('user_total_rating to',user_total_rating)
            //   }
            // });
        }
      });
    }

    //product page
    if($('body').hasClass('template-product') || $('body').hasClass('template-collection')){
      $('.header_review').each(function(){
        var $this = $(this);
        var store_place_id = $(this).attr('data-place-id');
        var google_rating = $this.attr('data-google-rating');
        var review_count = $this.attr('data-review-count');
        console.log(google_rating,review_count);
        if(google_rating && review_count){
            $($this).find('p').html(google_rating+'<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.54894 1.42705C4.8483 0.505741 6.1517 0.50574 6.45106 1.42705L6.95934 2.99139C7.09321 3.40341 7.47717 3.68237 7.9104 3.68237H9.55524C10.524 3.68237 10.9267 4.92199 10.143 5.49139L8.81232 6.4582C8.46183 6.71285 8.31518 7.16422 8.44905 7.57624L8.95733 9.14058C9.25669 10.0619 8.20221 10.828 7.41849 10.2586L6.08779 9.2918C5.7373 9.03715 5.2627 9.03715 4.91221 9.2918L3.58151 10.2586C2.7978 10.828 1.74331 10.0619 2.04267 9.14058L2.55095 7.57624C2.68483 7.16422 2.53817 6.71285 2.18768 6.4582L0.856976 5.49139C0.0732617 4.92199 0.476037 3.68237 1.44476 3.68237H3.0896C3.52283 3.68237 3.90678 3.40341 4.04066 2.99139L4.54894 1.42705Z" fill="#FFB800"/></svg>');
            $($this).find('span').html('('+review_count+')');
            $($this).show();
            // var service = new google.maps.places.PlacesService(document.getElementById(map_id));
            // service.getDetails({
            //   placeId: store_place_id
            // },
            // function(place, status) {
            //   if (status === google.maps.places.PlacesServiceStatus.OK) {
            //     var rating = place.rating;
            //     var user_total_rating = place.user_ratings_total;
            //     $($this).find('p').html(rating+'<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.54894 1.42705C4.8483 0.505741 6.1517 0.50574 6.45106 1.42705L6.95934 2.99139C7.09321 3.40341 7.47717 3.68237 7.9104 3.68237H9.55524C10.524 3.68237 10.9267 4.92199 10.143 5.49139L8.81232 6.4582C8.46183 6.71285 8.31518 7.16422 8.44905 7.57624L8.95733 9.14058C9.25669 10.0619 8.20221 10.828 7.41849 10.2586L6.08779 9.2918C5.7373 9.03715 5.2627 9.03715 4.91221 9.2918L3.58151 10.2586C2.7978 10.828 1.74331 10.0619 2.04267 9.14058L2.55095 7.57624C2.68483 7.16422 2.53817 6.71285 2.18768 6.4582L0.856976 5.49139C0.0732617 4.92199 0.476037 3.68237 1.44476 3.68237H3.0896C3.52283 3.68237 3.90678 3.40341 4.04066 2.99139L4.54894 1.42705Z" fill="#FFB800"/></svg>');
            //     if(user_total_rating > 999){
            //       var originalNumber = user_total_rating;
            //       var convertedNumber = originalNumber / 1000;
            //       var convertedNumber_new = convertedNumber;
            //       var roundedNumber = convertedNumber_new.toFixed(1);
                  
            //       console.log(parseFloat(roundedNumber)); // Output: 12.8
            //       $($this).find('span').html('('+parseFloat(roundedNumber)+'k)');
            //     }else{
            //       $($this).find('span').html('('+user_total_rating+')');
            //     }
            //     // $($this).find('.gallery-review .gallery-review-right span').html('('+user_total_rating+')');
            //     $($this).show();
            //     // console.log('ratings to',rating)
            //     // console.log('user_total_rating to',user_total_rating)
            //   }
            // });
        }
      });
    }
});

// quick view according
var $question = $('.acc-head');
var $answer = $('.acc-content');

$(document).on('click','.acc-head',function(){
  $('.acc-content').slideUp(1000);
  if($(this).hasClass('open')){
        $(this).removeClass('open').next('.acc-content').slideUp(1000);
    }else{
        $('.acc-head').removeClass('open');
        $(this).addClass('open').next('.acc-content').slideDown(1000);   
    }
});
// $(document).on('click',$question,function(){
// // $question.click(function(){
//     $answer.slideUp(1000);
//     if($(this).hasClass('open')){
//         $(this).removeClass('open')
//                .next($answer).slideUp(1000);
//     }else{
//         $question.removeClass('open');
//         $(this).addClass('open')
//                .next($answer).slideDown(1000);   
//     }
// });


$(document).ready(function() {
  if($('body').hasClass('template-product')){
        var isALARendered;
        function ALAcheck() {
          isALARendered = setInterval(function () {
            customALA()
          }, 200);
        }
        ALAcheck();
        function customALA() {
        var selector = $('.product-recommendations .grid-uniform');
          if(selector.length > 0) {
            clearInterval(isALARendered);        
              var $question = $('.acc-head');
              var $answer = $('.acc-content');
              $question.click(function(){
                  $answer.slideUp(1000);
                  if($(this).hasClass('open')){
                      $(this).removeClass('open')
                             .next($answer).slideUp(1000);
                  }else{
                      $question.removeClass('open');
                      $(this).addClass('open')
                             .next($answer).slideDown(1000);   
                  }
              });
          }  
        }
  }

  //new popup
  $('body').on('click', '.fancybox-container .size_chart_wrapper a', function(e){
    e.preventDefault();
    var window_width = $(window).width();
    console.log(window_width);
    if(window_width > 767){
      $(this).parents('.fancybox-container').find('.fancybox-content').animate({
      scrollTop: $(this).parents(".fancybox-container").find(".product-detail-tab .size_chart_tab").offset().top
      }, 1000);
      $(this).parents(".fancybox-container").find('.product-detail-tab .size_chart_tab').trigger('click');
    }else{
      $(this).parents('.fancybox-container').find('.fancybox-content').animate({
      scrollTop: $(this).parents(".fancybox-container").find(".accordion-item .size_chart_tab").offset().top
      }, 1000);
      if($(this).parents(".fancybox-container").find('.accordion-item.size_chart-accordion-item .size_chart_tab').hasClass('open')){
        
      }else{
        $(this).parents(".fancybox-container").find('.accordion-item .size_chart_tab').trigger('click');
      }
      
    }
    
  });

  $('body').on('click','[data-fancybox]', function(){
    // var dataSrc = $(this).attr('data-src');
    // // setTimeout(function(){
    // //   $(dataSrc).scrollTop(0);
    // // },500)
    // $(dataSrc).animate({
    //   scrollTop: $(dataSrc).offset().top
    //   }, 500);
      
  })





  $('body').on('click', '.pdp_template .size_chart_wrapper a', function(e){
      e.preventDefault();
      $([document.documentElement, document.body]).animate({
          scrollTop: $(".pdp_template .size_chart_tab").offset().top - 100
      }, 500);
      $('.pdp_template .product-detail-tab .size_chart_tab').trigger('click');
  });
    // $('.multiplevariant').fancybox({
    //     transitionEffect: 'none', // Set transition effect to none
    //     transitionDuration: 0,
    // });

   
    // document.getElementById('backButton').addEventListener('click', function() {
    //   goBackWithoutRepeating();
    // });

  // $('.as-cart--back-in').on('click', function(){
  //   goBackToDifferentPage();
  // });

  // function goBackToDifferentPage() {
  //     var currentUrl = window.location.href;
  //     // Get the stored history from localStorage
  //     var storedHistory = JSON.parse(localStorage.getItem('storedHistory')) || [];
  //     // Start iterating backward through the stored history
  //     for (var i = storedHistory.length - 1; i >= 0; i--) {
  //       // Get the URL of the previous page in stored history
  //       var previousUrl = storedHistory[i];
  //       // Check if the previous page's URL is different from the current page
  //       if (previousUrl !== currentUrl) {
  //         // Go back to the previous page with a different URL
  //         window.location.href = previousUrl;
  //         break;
  //       }
  //     }
  //   }

  //   // Function to update the stored history in localStorage
  //   function updateStoredHistory() {
  //     var currentUrl = window.location.href;
  //     var storedHistory = JSON.parse(localStorage.getItem('storedHistory')) || [];
  //     // Add the current URL to the stored history
  //     storedHistory.push(currentUrl);

  //     // Update the stored history in localStorage
  //     localStorage.setItem('storedHistory', JSON.stringify(storedHistory));
  //   }
  // updateStoredHistory();
 
});